<script setup lang="ts">
import { PropType } from 'vue'
import PostModel from '~/models/Discussion/Post'

const props = defineProps({
    post: {
        type: Object as PropType<PostModel>,
        default: null,
    },
    searchQueries: {
        type: Array,
        default: null,
    },
    typePost: {
        type: String,
        default: 'post',
        required: false,
    },
    categoryId: {
        type: Number,
        default: null,
        required: false,
    },
})

const showReportPostModal = () => {
    useNuxtApp().$bus.$emit('showModal', 'discussion-report-post-' + props.post.id)
}
</script>

<template>
    <div class="post">
        <div v-if="categoryId && typePost !== 'answer'" class="product-info">
            <nuxt-link v-if="post.product" :to="post.product.url" class="product-info__name">
                <span class="product-info__img">
                    <img v-if="post.product.image" :src="post.product.image" height="38" :alt="post.product.name" />
                </span>
                <span v-html="$highlightSearchedWord(post.product.name, searchQueries)"></span>
            </nuxt-link>

            <div class="post__info">
                <span class="product-info__date">{{ post.createdAt }}</span>

                <a href="#" class="post__report" @click.prevent="showReportPostModal">
                    <img src="/nuxt-assets/icons/report.svg" :alt="$t('Report')" class="mr-1" />
                    {{ $t('discussions.report') }}
                </a>
            </div>
        </div>

        <div v-else class="post__info">
            <span class="post__date">{{ post.createdAt }}</span>
            <a href="#" class="post__report" @click.prevent="showReportPostModal">
                <img src="/nuxt-assets/icons/report.svg" :alt="$t('Report')" class="mr-1" />
                {{ $t('discussions.report') }}
            </a>
        </div>

        <h3 class="post__title" v-html="$highlightSearchedWord(post.title, searchQueries)"></h3>

        <p class="post__description" v-html="$highlightSearchedWord(post.text, searchQueries)"></p>

        <objectsDiscussionModalsReportPostForm :post="post" />
    </div>
</template>

<style lang="scss" scoped>
.post {
    position: relative;
    padding-top: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__product {
        display: inline-flex;
        flex-direction: column;

        &__name {
            border-radius: 100px;
            background: $color-grey;
            color: $color-dark;
            padding: 9px 20px 9px 13px;
            display: flex;
            align-items: center;
            transition: all 0.2s;
            font-size: 14px;
            margin-bottom: 19px;
            width: fit-content;

            &:hover {
                color: $color-cta;
            }
        }

        &__img {
            width: 47px;
            height: 38px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    &__info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        @include screen-md {
            margin-bottom: 0;
        }
    }

    &__date {
        font-size: 12px;
        color: $color-dark;
    }

    &__report {
        font-size: 12px;
        color: $color-grey-semi-dark;
        transition: all 0.2s;

        &:hover {
            color: $color-grey-extra-dark;
        }

        @include screen-md {
            margin-top: 1rem;
            position: absolute;
            top: 0;
            right: 0;
        }
    }

    &__title {
        font-size: 18px;
        color: $color-dark;
        margin: 1rem 0 0;

        @include screen-md {
            font-weight: normal;
        }
    }

    &__description {
        font-size: 14px;
        line-height: 20px;
    }
}

.product-info {
    display: inline-flex;
    flex-direction: column;
    position: relative;

    @include screen-md {
        position: unset;
    }

    &__name {
        border-radius: 100px;
        background: $color-grey;
        color: $color-dark;
        padding: 9px 20px 9px 13px;
        display: flex;
        align-items: center;
        transition: all 0.2s;
        font-size: 14px;
        margin-bottom: 19px;

        @include screen-md {
            width: fit-content;
            max-width: 85%;
        }

        &:hover {
            color: $color-cta;
        }
    }

    &__img {
        width: 47px;
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &__date {
        font-size: 12px;
        color: $color-dark;
    }
}
</style>
